<script setup>
import { computed, inject, useSlots } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "@/Stores/domain";
import { StarIcon } from "@heroicons/vue/20/solid";

const props = defineProps({
    title: String,
    description: String,
    class: String,
});

const slots = useSlots();
const { t: __ } = useI18n();
</script>

<template>
    <div class="px-6 lg:px-8">
        <div
            v-if="!!slots.title || title || !!slots.description || description || !!slots.help"
            :class="[!!slots.title || title || !!slots.description || description ? 'justify-between' : 'justify-end', 'flex gap-6 mb-6']">
            <div v-if="!!slots.title || title || !!slots.description || description">
                <div v-if="!!slots.title || title" class="flex justify-between items-center text-lg text-gray-900 dark:text-white">
                    <slot name="title">{{ title }}</slot>
                </div>
                <div v-if="!!slots.description || description" :class="[!!slots.title || title ? 'mt-1' : '', 'text-sm text-gray-600 dark:text-gray-400']">
                    <slot name="description">{{ description }}</slot>
                </div>
            </div>
            <div v-if="!!slots.help">
                <slot name="help"></slot>
            </div>
        </div>
        <div class="relative space-y-6">
            <slot></slot>
        </div>
    </div>
</template>
